import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-16 bg-background-900/50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8 md:mb-10">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-500/20 text-accent-400">
              <i className="ri-apps-line" />
            </div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-100">热门分类</h2>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex items-start gap-4 p-4 md:p-5 rounded-xl bg-background-900 border border-background-800/50 hover:border-accent-500/30 hover:bg-background-800/50 transition-all"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-xl bg-accent-500/10 text-accent-400 group-hover:bg-accent-500/20 transition-colors shrink-0">
                <div className="w-6 h-6 flex items-center justify-center md:w-7 md:h-7">
                  <i className={`${cat.icon} text-xl md:text-2xl`} />
                </div>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between mb-1">
                  <h3 className="text-base md:text-lg font-bold text-foreground-200 group-hover:text-accent-300 transition-colors">
                    {cat.name}
                  </h3>
                  <span className="text-xs text-foreground-600 bg-background-800 px-2 py-0.5 rounded-full">
                    {cat.articleCount}篇
                  </span>
                </div>
                <p className="text-sm text-foreground-500 line-clamp-2 leading-relaxed">
                  {cat.description}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}